export const CLOUD_SETTING_BASE_URL = 'ows/v1/OutlookCloudSettings/settings/global';
export const COPILOT_THEME_IMAGE_SETTING_KEY = 'copilotthemeimage';
export const COPILOT_THEME_SETTING_NAME = 'copilotthemeoptions';
